<template>
  <div class="main-container">
    <h2 class="main-title bottom-row">Arena push notifications management</h2>
    <v-row>
      <v-select label="Select a campaign please"
                v-model="selectedGroup"
                :items="groupsSelectData"
                outlined
                dense
                hide-selected>
      </v-select>
    </v-row>
    <v-row>
      <v-text-field
              label="Push Engage Script URL"
              v-model="selectedArena.config.pushNotifications.peScript">
      </v-text-field>
    </v-row>
    <v-row>
      <v-text-field
              label="Push Engage Service Worker Script URL"
              v-model="selectedArena.config.pushNotifications.peServiceWorker">
      </v-text-field>
    </v-row>
    <v-row justify="end">
      <v-btn class="ma-2"
             v-if="$checkRoles(['Administrator'])"
             v-on:click="saveData"
             color="green">
        Save push notifications group choice
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import config from '../../../config';

export default {
    components: {},
    name: 'PushNotificationsTab',
    props: ['selectedArena'],
    data() {
        return {
            groups: [],
            selectedGroup: null,
            getDataPromise: null
        };
    },
    created: async function() {
        this.getDataPromise = this.getData();
        await this.computeSelectedGroup(this);
    },
    computed: {
        groupsSelectData: function() {
            return this.groups.map((item) => {
                return { text: item.name, value: item.name };
            });
        },
        arenaDomain: function() {
            return this.selectedArena.domain.replace('www.', '');
        }
    },
    watch: {
        selectedArena: async function(newValue, oldValue) {
            if (newValue) {
                await this.computeSelectedGroup(this);
            }
        }
    },
    methods: {
        getData: function() {
            return this.$http.get(`${config.apiUrl}/pushnotifications/campaigns-list`).then(
                (response) => {
                    let data = response.body;
                    this.groups = data.items || [];
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        computeSelectedGroup: async function() {
            await this.getDataPromise;
            // detect selected item by domain
            let arenaDomain = this.arenaDomain;
            let selectedGroup = this.groups.find((f) => f.arenas && f.arenas.some((arena) => arena === arenaDomain));

            if (selectedGroup) {
                this.selectedGroup = selectedGroup.name;
            } else {
                this.selectedGroup = null;
            }
        },
        saveData: async function() {
            let formData = new FormData();
            formData.append(
                'jsonData',
                JSON.stringify({
                    Group: this.selectedGroup,
                    Domain: this.arenaDomain,
                    PeScript: this.selectedArena.config.pushNotifications.peScript,
                    PeServiceWorker: this.selectedArena.config.pushNotifications.peServiceWorker
                })
            );

            await this.$http
                .post(`${config.apiUrl}/pushnotifications/add-arena-into-group`, formData)
                .then(
                    () => {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Success!',
                            text: 'Data was saved successfully'
                        });
                    },
                    (error) => {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Error!',
                            text: 'Something went wrong, please contact WebPortals.'
                        });
                        console.log(error);
                    }
                )
                .then((_) => {
                    this.getDataPromise = this.getData();
                });
        }
    }
};
</script>
